import {
  getNotificationBlockId,
  getObjectAddressBlockId,
  getObjectBlockId,
  getObjectDangerClassBlockId,
  getObjectKindBlockId,
  getObjectManualAddressBlockId,
  getObjectNameBlockId,
  getObjectRegionBlockId,
  getObjectRiskCategoryBlockId,
  getObjectSubKindBlockId,
  getObjectTypeBlockId,
  KNM_NOTIFICATION_BLOCK_ID,
} from 'KnmPackage/MainModule/constants/fieldsElementsIds';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { isLaterThanAdminSetting } from 'CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';

import { KnmErknmFormFieldsNamesTemplatesEnum } from '../enums/KnmErknmFormFieldsNamesTemplatesEnum';
import {
  KNO_ORGANIZATION_BLOCK_ID,
  START_DATE_BLOCK_ID,
  STOP_DATE_BLOCK_ID,
  DURATION_DAYS_BLOCK_ID,
  DURATION_HOURS_BLOCK_ID,
  DIRECT_DURATION_DAYS_BLOCK_ID,
  KIND_CONTROL_BLOCK_ID,
  KIND_KNM_BLOCK_ID,
  TYPE_BLOCK_ID,
  PLAN_ID_BLOCK_ID,
  APPROVE_REQUIRED_BLOCK_ID,
  PROSECUTOR_ORGANIZATION_BLOCK_ID,
  OBJECTS_BLOCK_ID,
  COLLABORATING_ORGANIZATIONS_BLOCK_ID,
  APPROVED_ON_PAPER_DOCUMENTS_BLOCK_ID,
  OLD_KNM_NUMBER,
  OLD_PLAN_NUMBER,
  ORGANIZATIONS_BLOCK_ID,
  getOrganizationBlockId,
  INSPECTORS_BLOCK_ID,
  REASONS_BLOCK_ID,
  EXPERTS_BLOCK_ID,
  REASON_DOCUMENTS_BLOCK_ID,
  getReasonDocumentBlockId,
  REMOTE_NOTE_ID,
  EVENTS_BLOCK_ID,
  getEventBlockId,
  REQUIREMENTS_BLOCK_ID,
  getRequirementBlockId,
  APPROVE_DOCS_BLOCK_ID,
  getApproveDocBlockId,
  PLACES_BLOCK_ID,
  getPlaceBlockId,
  ORGANIZATION_DOCUMENTS_BLOCK_ID,
  getOrganizationDocumentBlockId,
  ACTS_BLOCK_ID,
  getActBlockId,
  RESULT_DECISIONS_BLOCK_ID,
  getResultDecisionBlockId,
  getCollaboratingOrganizationBlockId,
  getDocumentBlockId,
  getInspectorBlockId,
  getReasonBlockId,
  getExpertBlockId,
  APPROVE_NOTE_BLOCK_ID,
  APPROVE_NOTE_APPEAL_BLOCK_ID,
  APPROVED_BLOCK_ID,
  CHECLISTS_BLOCK_ID,
  getReasonDocumentAttachmentsBlockId,
  LINKS_BLOCK_ID,
  JUDGMENTS_BLOCK_ID,
  getJudgmentBlockId,
  getJudgmentDateBlockId,
  getJudgmentNumberBlockId,
  getJudgmentKindBlockId,
  getJudgmentRfRegionBlockId,
  getJudgmentCourtLevelBlockId,
  getJudgmentCourtBlockId,
  getJudgmentActionBlockId,
  getJudgmentSubjectDataBlockId,
  getJudgmentCanceledJudgmentsBlockId,
  getJudgmentAttachmentBlockId,
  INTERACTION_CATEGORY_ID,
  REJECTED_REASON_TYPE_BLOCK_ID,
  getSuspensionEventBlockId,
  getActEventsBlockId,
  MANUAL_ADDRESS_BLOCK_ID,
  REGION_BLOCK_ID,
  PLACE_DECISION_BLOCK_ID,
  getVideoCallInfoBlockId,
  FIO_SIGNER_BLOCK_ID,
  TITLE_SIGNER_BLOCK_ID,
  ABROGATION_REASON_ID_BLOCK_ID,
  ABROGATION_LINK_BLOCK_ID,
  getReschedulingBlockId,
  DOC_TARGET_BLOCK_ID,
  VIDEO_CALL_INFO_WRAPPER_BLOCK_ID,
  STOP_TIME_BLOCK_ID,
  getComplexDataBlockId,
  getEventTypeBlockId,
  getEventInteractionCategoryBlockId,
  getEventStartDateBlockId,
  getEventStopDateBlockId,
  getOrganizationMspBlockId,
  getOrganizationSonkoBlockId,
  getOrganizationNkoBlockId,
  getReasonRiskIndicatorsBlockId,
  getActNumberBlockId,
  getActHoldingDateTimeBlockId,
  getActDurationDays,
  getActDurationHours,
  getActOrganizationTemplateBlockId,
  DATA_CONTENT_BLOCK_ID,
  getApproveRemarkBlockId,
  TEXT_REACT_QUILL_EDITOR_BLOCK_ID,
  getAgreementsBlockId,
  getReasonDocumentViolationEvidencesBlockId,
  getReasonViolationEvidencesBlockId,
  KNM_APPROVE_CHANGE_KNM,
  getNormalizedEventKnmBlockId,
  REASON_PASSPORT_LINKS_BLOCK_ID,
  getResultDecisionNumberDecisionBlockId,
  getResultDecisionDateDecisionBlockId,
  getResultDecisionIsProsecutionBlockId,
  getResultDecisionResponsibleEntitiesBlockId,
  getResultDecisionKindDecisionBlockId,
  getResultDecisionResponsibleEntityResponsibilityTypeBlockId,
  getResultDecisionResponsibleEntityStructuresNPABlockId,
  getResultDecisionResponsibleEntities,
} from './knmErknmFieldsElementsIds';

interface IFieldData {
  title: string;
  getScrollElementId: (id?: string) => string;
  getReserveScrollElementId?: (id?: string) => string;
}
export const INN_LABEL_BLOCK_ID = 'innLabelBlock';
export const OGRN_LABEL_BLOCK_ID = 'orgnLabelBlock';
export const ORGANIZATION_NAME_BLOCK_ID = 'organizationNameBlock';
export const OKVEDS_BLOCK_ID = 'okvedsBlock';
export const SNILS_BLOCK_ID = 'snilsBlockId';
export const DOCUMENT_BLOCK_ID = 'documentBlockId';
export const COUNTRY_BLOCK_ID = 'countryBlockId';
export const RAFP_NZA_BLOCK_ID = 'rafpNzaBlockId';
export const KPP_BLOCK_ID = 'kppBlockId';
export const IS_UNABLE_TO_REFUSE_BLOCK_ID = 'isUnableToRefuseBlock';
export const knmErknmFieldsDataByFlatNameMap = (
  created: string | null | undefined,
  settings: IAdminSetting[] | undefined,
): Record<KnmErknmFormFieldsNamesTemplatesEnum[number], IFieldData> => {
  const isEnablePaperlessPassportDocument = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.ENABLED_PAPERLESS_PASSPORT_4_1_3_STARTS_FROM,
  );

  return {
    [KnmErknmFormFieldsNamesTemplatesEnum.MANUAL_ADDRESS]: {
      title: 'Место вынесения решения - Адрес',
      getScrollElementId: () => MANUAL_ADDRESS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REGION]: {
      title: 'Место вынесения решения - Регион',
      getScrollElementId: () => REGION_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESCHEDULING_NEW_START_DATE_ID]: {
      title: 'Сведения о переносе мероприятия - Новая дата начала КНМ',
      getScrollElementId: (id: string) => getReschedulingBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESCHEDULING_NEW_END_DATE_ID]: {
      title: 'Сведения о переносе мероприятия - Новая дата окнчания КНМ',
      getScrollElementId: (id: string) => getReschedulingBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESCHEDULING_NEW_DURATION_DAYS_ID]: {
      title: 'Сведения о переносе мероприятия - новый срок непосредственного взаимодействия (дней)',
      getScrollElementId: (id: string) => getReschedulingBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESCHEDULING_NEW_DURATION_HOURS_ID]: {
      title: 'Сведения о переносе мероприятия - новый срок непосредственного взаимодействия (часов)',
      getScrollElementId: (id: string) => getReschedulingBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ABROGATION_REASON_ID]: {
      title: 'Сведения об отмене мероприятия - Основание для отмены',
      getScrollElementId: () => ABROGATION_REASON_ID_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ABROGATION_LINK]: {
      title: 'Сведения об отмене мероприятия - Ссылка на профилактический визит',
      getScrollElementId: () => ABROGATION_LINK_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.KNO_ORGANIZATION]: {
      title: 'Наименование органа контроля',
      getScrollElementId: () => KNO_ORGANIZATION_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.PLACE_DECISION]: {
      title: 'Место вынесения решения',
      getScrollElementId: () => PLACE_DECISION_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.FIO_SINGER]: {
      title: 'ФИО должностного лица',
      getScrollElementId: () => FIO_SIGNER_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.TITLE_SINGER]: {
      title: 'Должность лица, подписавшего решение',
      getScrollElementId: () => TITLE_SIGNER_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.START_DATE]: {
      title: 'Дата начала КНМ',
      getScrollElementId: () => START_DATE_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.START_TIME]: {
      title: 'Время начала КНМ',
      getScrollElementId: () => STOP_DATE_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.STOP_DATE]: {
      title: 'Дата окончания КНМ',
      getScrollElementId: () => STOP_DATE_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.STOP_TIME]: {
      title: 'Время окончания КНМ',
      getScrollElementId: () => STOP_TIME_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.DURATION_DAYS]: {
      title: 'Срок проведения (дней)',
      getScrollElementId: () => DURATION_DAYS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.DURATION_HOURS]: {
      title: 'Срок непосредственного взаимодействия (часов)',
      getScrollElementId: () => DURATION_HOURS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.DIRECT_DURATION_DAYS]: {
      title: 'Срок непосредственного взаимодействия (дней)',
      getScrollElementId: () => DIRECT_DURATION_DAYS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.KIND_CONTROL]: {
      title: 'Вид контроля (надзора) и его номер',
      getScrollElementId: () => KIND_CONTROL_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_ERKNM_TEXT_REACT_QUILL_EDITOR]: {
      title: 'Основание проведения - дополнительно',
      getScrollElementId: () => TEXT_REACT_QUILL_EDITOR_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.KIND_KNM]: {
      title: 'Вид КНМ',
      getScrollElementId: () => KIND_KNM_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.TYPE]: {
      title: 'Характер КНМ',
      getScrollElementId: () => TYPE_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.TYPE_2]: {
      title: 'Необходимо заполнить поле "Вид контроля (надзора) и его номер"',
      getScrollElementId: () => TYPE_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.PLAN_ID]: {
      title: 'Номер плана',
      getScrollElementId: () => PLAN_ID_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.PLAN_SELECT_OPTION]: {
      title: 'Номер плана',
      getScrollElementId: () => PLAN_ID_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.APPROVE_REQUIRED]: {
      title: 'Необходимость согласования',
      getScrollElementId: () => APPROVE_REQUIRED_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.DATA_CONTENT]: {
      title:
        'Сведения о причинении вреда (ущерба) или об угрозе причинения вреда (ущерба) охраняемым законом ценностям в случаях отсутствия необходимости согласования проведения контрольного (надзорного) мероприятия с органами прокуратуры в соответствии со статьей 66 Федерального закона',
      getScrollElementId: () => DATA_CONTENT_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.DOC_TARGET]: {
      title: 'Разрешительные и иные документы',
      getScrollElementId: () => DOC_TARGET_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.DOC_TARGET_ITEM]: {
      title: 'Разрешительные и иные документы',
      getScrollElementId: () => DOC_TARGET_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.DOC_TARGET_ITEM_DOC_TARGET_TYPE]: {
      title: 'Разрешительные и иные документы - Тип документа',
      getScrollElementId: () => DOC_TARGET_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.DOC_TARGET_ITEM_ERVK_CONTROL_KIND_DOC_TARGET]: {
      title: 'Разрешительные и иные документы',
      getScrollElementId: () => DOC_TARGET_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.PROSECUTOR_ORGANIZATION]: {
      title: 'Наименование прокуратуры',
      getScrollElementId: () => PROSECUTOR_ORGANIZATION_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.APPROVE_NOTE]: {
      title: 'Комментарий в сведениях о согласовании проведения КНМ с органами прокуратуры',
      getScrollElementId: () => APPROVE_NOTE_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.APPROVE_NOTE_APPEAL]: {
      title: 'Сведения об обжаловании',
      getScrollElementId: () => APPROVE_NOTE_APPEAL_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.APPROVE_REMARKS_REMARK]: {
      title: 'Замечание',
      getScrollElementId: (id: string) => getApproveRemarkBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.APPROVED]: {
      title: 'Решение по заявлению',
      getScrollElementId: () => APPROVED_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.APPROVED_NUMBER_DECISION]: {
      title: 'Решение по заявлению - Номер решения',
      getScrollElementId: () => APPROVED_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.APPROVED_DATE_DECISION]: {
      title: 'Решение по заявлению - Дата решения',
      getScrollElementId: () => APPROVED_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.APPROVED_FIO_SINGER]: {
      title: 'Решение по заявлению - Кем принято решение',
      getScrollElementId: () => APPROVED_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.APPROVED_TITLE_SINGER]: {
      title: 'Решение по заявлению - Должность лица, подписавшего решение',
      getScrollElementId: () => APPROVED_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.APPROVED_FILE]: {
      title: 'Решение по заявлению - Файл решения',
      getScrollElementId: () => APPROVED_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REJECTED_REASON_TYPE]: {
      title: 'Причина отказа',
      getScrollElementId: () => REJECTED_REASON_TYPE_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATIONS]: {
      title: 'Сведения о контролируемом лице',
      getScrollElementId: () => ORGANIZATIONS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION]: {
      title: 'Контролируемое лицо',
      getScrollElementId: (id: string) => getOrganizationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_SUBJECT_TYPE]: {
      title: 'Контролируемое лицо - Тип контролируемого лица',
      getScrollElementId: (id: string) => getOrganizationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_IS_PRESENT_IN_IT_REGISTRY]: {
      title: 'Контролируемое лицо - Наличие в реестре аккредитованных IT-организаций',
      getScrollElementId: (id: string) => getOrganizationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_IS_SONKO_REGISTRY]: {
      title: 'Контролируемое лицо - Наличие проверяемого лица в реестре СОНКО',
      getScrollElementId: (id: string) => getOrganizationSonkoBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_IS_MSP_REGISTRY]: {
      title: 'Контролируемое лицо - Наличие проверяемого лица в реестре МСП',
      getScrollElementId: (id: string) => getOrganizationMspBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_IS_NKO_REGISTRY]: {
      title: 'Контролируемое лицо - Наличие проверяемого лица в реестре НКО',
      getScrollElementId: (id: string) => getOrganizationNkoBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_OGRN]: {
      title: 'Контролируемое лицо - Основной государственный регистрационный номер (ОГРН)',
      getScrollElementId: (id: string) => getOrganizationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_INN]: {
      title: 'Контролируемое лицо - Идентификационный номер налогоплательщика (ИНН)',
      getScrollElementId: (id: string) => getOrganizationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_OKVEDS]: {
      title: 'Список ОКВЭД',
      getScrollElementId: (id: string) => getOrganizationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_OKVED]: {
      title: 'ОКВЭД',
      getScrollElementId: (id: string) => getOrganizationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_OKVED_OKVED]: {
      title: 'ОКВЭД',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_RAFP_NZA]: {
      title: 'Номер записи об аккредитации в РАФП',
      getScrollElementId: (id: string) => getOrganizationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_KPP]: {
      title: 'Код причины постановки на учет (КПП)',
      getScrollElementId: (id: string) => getOrganizationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_SNILS]: {
      title: 'Страховой номер индивидуального лицевого счета (СНИЛС)',
      getScrollElementId: (id: string) => getOrganizationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_COUNTRY]: {
      title: 'Государство, в котором указанное юридическое лицо зарегистрировано',
      getScrollElementId: (id: string) => getOrganizationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATIONS_ADDRESS]: {
      title: 'Адрес места нахождения',
      getScrollElementId: (id: string) => getOrganizationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATIONS_FIAS_REGION]: {
      title: 'Адрес места нахождения - Субъект РФ',
      getScrollElementId: (id: string) => getOrganizationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_DOCUMENT]: {
      title: 'Сведения о документе, удостоверяющем личность',
      getScrollElementId: (id: string) => getOrganizationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.OBJECTS]: {
      title: 'Сведения об объектах контроля',
      getScrollElementId: () => OBJECTS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.OBJECT]: {
      title: 'Объект проведения КНМ',
      getScrollElementId: (id: string) => getObjectBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_NAME]: {
      title: 'Наименование объекта проведения',
      getScrollElementId: (id: string) => getObjectNameBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.OBJECT_ADDRESS]: {
      title: 'Местонахождение объекта проведения',
      getScrollElementId: (id: string) => getObjectAddressBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_TYPE]: {
      title: 'Тип объекта проведения',
      getScrollElementId: (id: string) => getObjectTypeBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_KIND]: {
      title: 'Вид объекта проведения',
      getScrollElementId: (id: string) => getObjectKindBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_SUB_KIND]: {
      title: 'Подвид объекта проведения',
      getScrollElementId: (id: string) => getObjectSubKindBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.OBJECT_RISK_CATEGORY]: {
      title: 'Категория риска объекта проведения',
      getScrollElementId: (id: string) => getObjectRiskCategoryBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.OBJECT_REGION]: {
      title: 'Регион местонахождения объекта проведения',
      getScrollElementId: (id: string) => getObjectRegionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.OBJECT_MANUAL_ADDRESS]: {
      title: 'Адрес местонахождения объекта проведения',
      getScrollElementId: (id: string) => getObjectManualAddressBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.OBJECT_DANGER_CLASS]: {
      title: 'Класс опасности объекта проведения',
      getScrollElementId: (id: string) => getObjectDangerClassBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATIONS]: {
      title: 'Список органов контроля, с которыми КНМ проводится совместно',
      getScrollElementId: () => COLLABORATING_ORGANIZATIONS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATIONS_ITEM]: {
      title: 'Наименование органа контроля, с которым КНМ проводится совместно',
      getScrollElementId: (id: string) => getCollaboratingOrganizationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATIONS_ITEM_ORGANIZATION]: {
      title: 'Наименование органа контроля, с которым КНМ проводится совместно',
      getScrollElementId: (id: string) => getCollaboratingOrganizationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATIONS_ITEM_TITLE]: {
      title: 'Наименование органа контроля, с которым КНМ проводится совместно',
      getScrollElementId: (id: string) => getCollaboratingOrganizationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.APPROVED_ON_PAPER_DOCUMENTS_ATTACHMENTS]: {
      title: 'Решение прокурора (на бумаге)',
      getScrollElementId: () => APPROVED_ON_PAPER_DOCUMENTS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.VIDEO_CALL_INFO]: {
      title: 'Видео-конференц-связь',
      getScrollElementId: () => VIDEO_CALL_INFO_WRAPPER_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.VIDEO_CALL_INFO_ITEM]: {
      title: 'Видео-конференц-связь',
      getScrollElementId: (id: string) => getVideoCallInfoBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.VIDEO_CALL_INFO_ITEM_LINK]: {
      title: 'Видео-конференц-связь - Ссылка на видеосозвон',
      getScrollElementId: (id: string) => getVideoCallInfoBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.VIDEO_CALL_INFO_ITEM_DATE_TIME]: {
      title: 'Видео-конференц-связь - Дата и время проведения видеосозвона',
      getScrollElementId: (id: string) => getVideoCallInfoBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.DOCUMENT_TYPE]: {
      title: 'Тип документа',
      getScrollElementId: (id: string) => getDocumentBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.DOCUMENT_ATTACHMENTS]: {
      title: 'Файлы',
      getScrollElementId: (id: string) => getDocumentBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.OLD_KNM_NUMBER]: {
      title: 'Номер проверки 294-ФЗ',
      getScrollElementId: () => OLD_KNM_NUMBER,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.OLD_PLAN_NUMBER]: {
      title: 'Номер плана 294-ФЗ',
      getScrollElementId: () => OLD_PLAN_NUMBER,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.INSPECTORS]: {
      title: 'Сведения о должностных лицах, участвующих в КНМ',
      getScrollElementId: () => INSPECTORS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_DOCUMENT_ATTACHMENTS]: {
      title: 'Сведения о решениях, принятых по результатам КНМ - Файл решения',
      getScrollElementId: (id: string) => getResultDecisionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_PROTOCOL_ATTACHMENTS]: {
      title: 'Сведения о решениях, принятых по результатам КНМ - Файл протокола',
      getScrollElementId: (id: string) => getResultDecisionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_PUNISHMENT_NATURE]: {
      title: 'Сведения о решениях, принятых по результатам КНМ - Характер наказания',
      getScrollElementId: (id: string) => getResultDecisionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.INSPECTOR]: {
      title: 'Должностное лицо, участвующее в КНМ',
      getScrollElementId: (id: string) => getInspectorBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.INSPECTOR_FULL_NAME]: {
      title: 'ФИО должностного лица, участвующего в КНМ',
      getScrollElementId: (id: string) => getInspectorBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.INSPECTOR_POSITION]: {
      title: 'Должность должностного лица, участвующего в КНМ',
      getScrollElementId: (id: string) => getInspectorBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASONS]: {
      title: 'Основание проведения КНМ / включения в план',
      getScrollElementId: () => REASONS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON]: {
      title: 'Основание регистрации КНМ',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_TYPE]: {
      title: 'Основание проведения мероприятия',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_LINK_VALIDATION]: {
      title: 'Ссылка на другой паспорт КНМ или ПМ',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_TEXT]: {
      title: 'Дополнительно',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_DATE]: {
      title: 'Дата основания регистрации КНМ',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_REQUIREMENT_ORDER]: {
      title: 'Номер поручения',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_DATE_REQUIREMENT]: {
      title: 'Дата требования регистрации КНМ',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATORS_VALUE]: {
      title: 'Индикатор риска',
      getScrollElementId: (id: string) => getReasonRiskIndicatorsBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATOR_VALUE]: {
      title: 'Индикатор риска',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATOR]: {
      title: 'Индикатор риска',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATOR_AUTO]: {
      title: 'Индикатор риска срабатывает в автоматическом режиме',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATOR_FILE]: {
      title: 'Файл индикатора риска',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_ASSIGNMENT_NUMBER]: {
      title: 'Номер поручения',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_ASSIGNMENT_DATE]: {
      title: 'Дата поручения',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_ASSIGNMENT_FULLNAME]: {
      title: 'ФИО лица, издавшего поручение',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_REQUIREMENT_DETAILS]: {
      title: 'Реквизиты требования',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_LINKS]: {
      title: 'Ссылка на другой паспорт КНМ или ПМ',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_LAST_CONDUCTED_KNM_DATE]: {
      title: 'Дата',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_PROGRAM_NUMBER]: {
      title: 'Номер программы проверок',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_PROGRAM_ATTACHMENT]: {
      title: 'Файл программы проверок',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.EXPERTS]: {
      title:
        'Сведения об экспертах, экспертных организациях, специалистах, независимых органах инспекции, саморегулируемых организациях и иных лицах',
      getScrollElementId: () => EXPERTS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.EXPERT]: {
      title: 'Эксперт',
      getScrollElementId: (id: string) => getExpertBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.EXPERT_TITLE]: {
      title: 'Наименование эксперта',
      getScrollElementId: (id: string) => getExpertBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.EXPERT_TYPE]: {
      title: 'Тип эксперта',
      getScrollElementId: (id: string) => getExpertBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_DOCUMENTS]: {
      title: 'Основания для проведения проверки',
      getScrollElementId: () => REASON_DOCUMENTS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_DOCUMENT]: {
      title: 'Основание для проведения проверки',
      getScrollElementId: (id: string) => getReasonDocumentBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_DOCUMENT_TYPE]: {
      title: 'Тип документа основания для проведения проверки',
      getScrollElementId: (id: string) => getReasonDocumentBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.INTERACTION_CATEGORY]: {
      title: 'Сведения об использовании в рамках КНМ средств дистанционного взаимодействия с контролируемыми лицами',
      getScrollElementId: () => INTERACTION_CATEGORY_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REMOTE_NOTE]: {
      title: 'Сведения об использовании в рамках КНМ средств дистанционного взаимодействия с контролируемыми лицами',
      getScrollElementId: () => REMOTE_NOTE_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_DOCUMENT_ATTACHMENTS]: {
      title: 'Документы основания для проведения проверки',
      getScrollElementId: (id: string) => getReasonDocumentAttachmentsBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_DOCUMENT_VIOLATION_EVIDENCES]: {
      title: 'Ссылка на видеозапись или фотоматериалы',
      getScrollElementId: (id: string) => getReasonDocumentViolationEvidencesBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_DOCUMENT_VIOLATION_EVIDENCES_DATE]: {
      title: 'Ссылка на видеозапись или фотоматериалы - Дата фиксации',
      getScrollElementId: (id: string) => id,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_DOCUMENT_VIOLATION_EVIDENCES_LINK]: {
      title: 'Ссылка на видеозапись или фотоматериалы - Ссылка',
      getScrollElementId: (id: string) => id,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_PASSPORT_LINKS]: {
      title: 'Ссылка на паспорт Решения',
      getScrollElementId: () => REASON_PASSPORT_LINKS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_VIOLATION_EVIDENCES]: {
      title: 'Ссылка на видеозапись или фотоматериалы',
      getScrollElementId: (id: string) => getReasonViolationEvidencesBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_VIOLATION_EVIDENCES_LINK]: {
      title: 'Ссылка на видеозапись или фотоматериалы - Ссылка',
      getScrollElementId: (id: string) => id,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REASON_DOCUMENT_VIOLATION_EVIDENCES_DESCRIPTION]: {
      title: 'Ссылка на видеозапись или фотоматериалы - Фиксация потенциального нарушения',
      getScrollElementId: (id: string) => id,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.EVENTS]: {
      title: 'Перечень действий, осуществляемых в рамках КНМ',
      getScrollElementId: () => EVENTS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.EVENT]: {
      title: 'Действие, осуществляемое в рамках КНМ',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.EVENT_TYPE]: {
      title: 'Тип действия, осуществляемого в рамках КНМ',
      getScrollElementId: (id: string) => getEventTypeBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.EVENT_INTERACTION_CATEGORY]: {
      title: 'Категория взаимодействия осуществляемого действия',
      getScrollElementId: (id: string) => getEventInteractionCategoryBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.EVENT_START_DATE]: {
      title: 'Дата начала действия, осуществляемого в рамках КНМ',
      getScrollElementId: (id: string) => getEventStartDateBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.EVENT_STOP_DATE]: {
      title: 'Дата окончания действия, осуществляемого в рамках КНМ',
      getScrollElementId: (id: string) => getEventStopDateBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.EVENT_SUBMITTED_DOCUMENTS]: {
      title: 'Перечень действий - Представляемые документы',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.EVENT_SUBMITTED_DOCUMENTS_TITLE_ID]: {
      title: 'Перечень действий - Представляемые документы - Наименование',
      getScrollElementId: (id: string) => getNormalizedEventKnmBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.EVENT_SUBMITTED_DOCUMENTS_REQUEST_DATETIME_ID]: {
      title: 'Перечень действий - Представляемые документы - Дата и время запроса',
      getScrollElementId: (id: string) => getNormalizedEventKnmBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.EVENT_SUBMITTED_DOCUMENTS_DEADLINE_ID]: {
      title: 'Перечень действий - Представляемые документы - Срок представления',
      getScrollElementId: (id: string) => getNormalizedEventKnmBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.EVENT_SUBMITTED_DOCUMENTS_FILE_ID]: {
      title: 'Перечень действий - Представляемые документы - Файл',
      getScrollElementId: (id: string) => getNormalizedEventKnmBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.EVENT_SUBMITTED_DOCUMENTS_SUBMISSION_DATETIME_ID]: {
      title: 'Перечень действий - Представляемые документы - Дата и время получения документа',
      getScrollElementId: (id: string) => getNormalizedEventKnmBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REQUIREMENTS]: {
      title: 'Обязательные требования, подлежащие проверке',
      getScrollElementId: () => REQUIREMENTS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REQUIREMENT]: {
      title: 'Обязательное требование, подлежащее проверке',
      getScrollElementId: (id: string) => getRequirementBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REQUIREMENT_MANUAL_TITLE]: {
      title: 'Обязательное требование, подлежащее проверке - Наименование',
      getScrollElementId: (id: string) => getRequirementBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REQUIREMENT_MANUAL_NAME_NPA]: {
      title: 'Обязательное требование, подлежащее проверке - Наименование НПА',
      getScrollElementId: (id: string) => getRequirementBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REQUIREMENT_MANUAL_DATE_NPA]: {
      title: 'Обязательное требование, подлежащее проверке - Дата НПА',
      getScrollElementId: (id: string) => getRequirementBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.APPROVE_DOCS]: {
      title: 'Разрешительные и иные документы',
      getScrollElementId: () => APPROVE_DOCS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.APPROVE_DOC]: {
      title: 'Разрешительный или иной документ',
      getScrollElementId: (id: string) => getApproveDocBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.APPROVE_DOC_APPROVE_DOC]: {
      title: 'Разрешительный или иной документ',
      getScrollElementId: (id: string) => getApproveDocBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.LINKS]: {
      title: 'Ссылка на другой паспорт КНМ или ПМ',
      getScrollElementId: () => LINKS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.PLACES]: {
      title: 'Место (места) проведения контрольного (надзорного) мероприятия',
      getScrollElementId: () => PLACES_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.CHECKLISTS]: {
      title: 'Проверочные листы',
      getScrollElementId: () => CHECLISTS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.CHECKLIST_CHECK]: {
      title: 'Проверочный лист',
      getScrollElementId: () => CHECLISTS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.CHECKLIST_ERVK_CHECK]: {
      title: 'Номер и название из ЕРВК',
      getScrollElementId: () => CHECLISTS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.CHECKLIST_NEW_TITLE]: {
      title: 'Наименование проверочного листа',
      getScrollElementId: () => CHECLISTS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.CHECKLIST_QUESTIONS]: {
      title: 'Контрольные вопросы',
      getScrollElementId: () => CHECLISTS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.CHECKLIST_QUESTION_TITLE]: {
      title: 'Контрольный вопрос',
      getScrollElementId: () => CHECLISTS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.PLACE]: {
      title: 'Место проведения контрольного (надзорного) мероприятия',
      getScrollElementId: (id: string) => getPlaceBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.PLACE_VALUE]: {
      title: 'Место проведения контрольного (надзорного) мероприятия',
      getScrollElementId: (id: string) => getPlaceBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.PLACE_REGION]: {
      title: 'Место проведения контрольного (надзорного) мероприятия - Субъект РФ',
      getScrollElementId: (id: string) => getPlaceBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.PLACE_MANUAL_ADDRESS]: {
      title: 'Место проведения контрольного (надзорного) мероприятия',
      getScrollElementId: (id: string) => getPlaceBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.PLACE_FIAS_REGION]: {
      title: 'Место проведения контрольного (надзорного) мероприятия - Субъект РФ',
      getScrollElementId: (id: string) => getPlaceBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_DOCUMENTS]: {
      title: 'Перечень представляемых контролируемыми лицами документов',
      getScrollElementId: () => ORGANIZATION_DOCUMENTS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_DOCUMENT_ITEM]: {
      title: 'Представляемый контролируемыми лицами документ',
      getScrollElementId: (id: string) => getOrganizationDocumentBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_DOCUMENT_VALUE]: {
      title: 'Наименование представляемого контролируемыми лицами документа',
      getScrollElementId: (id: string) => getOrganizationDocumentBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACTS]: {
      title: 'Акты',
      getScrollElementId: () => ACTS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT]: {
      title: 'Акт',
      getScrollElementId: (id: string) => getActBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_TEMPLATE]: {
      title: 'Акт - Контролируемое лицо',
      getScrollElementId: (id: string) => getActOrganizationTemplateBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_CREATION_ACT_DATE_TIME]: {
      title: 'Акт - Дата и время составления акта КНМ',
      getScrollElementId: (id: string) => getActBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_SUBJECT_TYPE]: {
      title: 'Акт - Тип контролируемого лица',
      getScrollElementId: (id: string) => `${getActBlockId(id)}.subjectType`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_OGRN]: {
      title: 'Акт - Основной государственный регистрационный номер (ОГРН)',
      getScrollElementId: (id: string) => getActBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_INN]: {
      title: 'Акт - Идентификационный номер налогоплательщика (ИНН)',
      getScrollElementId: (id: string) => `${getActBlockId(id)}.innLabelBlock`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_RAFPNZA]: {
      title: 'Акт - Номер записи об аккредитации в РАФП',
      getScrollElementId: (id: string) => `${getActBlockId(id)}.rafpNzaLabelBlock`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_KPP]: {
      title: 'Акт - Код причины постановки на учет (КПП)',
      getScrollElementId: (id: string) => `${getActBlockId(id)}.kppLabelBlock`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_NAME]: {
      title: 'Акт - Наименование проверяемого лица',
      getScrollElementId: (id: string) => `${getActBlockId(id)}.organizationNameBlock`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_LOCATION_ADDRESS]: {
      title: 'Акт - Адрес места нахождения',
      getScrollElementId: (id: string) => `${getActBlockId(id)}.addressBlock`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_COUNTRY]: {
      title: 'Акт - Государство, в котором указанное юридическое лицо зарегистрировано',
      getScrollElementId: (id: string) => getActBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_DOCUMENT]: {
      title: 'Акт - Сведения о документе, удостоверяющем личность',
      getScrollElementId: (id: string) => `${getActBlockId(id)}.document`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_SNILS]: {
      title: 'Акт - Страховой номер индивидуального лицевого счета (СНИЛС)',
      getScrollElementId: (id: string) => `${getActBlockId(id)}.snils`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_IS_PRESENT_IN_IT_REGISTRY]: {
      title: 'Акт - Контролируемое лицо - Наличие в реестре аккредитованных IT-организаций',
      getScrollElementId: (id: string) => getActBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_IS_SONKO_REGISTRY]: {
      title: 'Акт - Контролируемое лицо - Наличие проверяемого лица в реестре СОНКО',
      getScrollElementId: (id: string) => getActBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_IS_MSP_REGISTRY]: {
      title: 'Акт - Контролируемое лицо - Наличие проверяемого лица в реестре МСП',
      getScrollElementId: (id: string) => getActBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_IS_NKO_REGISTRY]: {
      title: 'Акт - Контролируемое лицо - Наличие проверяемого лица в реестре NKO',
      getScrollElementId: (id: string) => getActBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_TYPE]: {
      title: 'Акт - Способ уведомления',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_NOTICE_DATE]: {
      title: 'Акт - Дата уведомления',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_NOTE]: {
      title: 'Акт - Примечание',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_REMARKS_TEXT]: {
      title: 'Акт - Замечание - Текст замечания',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_REMARKS_TEXT_REACT_QUILL_EDITOR]: {
      title: 'Акт - Замечание - Текст замечания',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_REMARKS_SIGNER_FULLNAME]: {
      title: 'Акт - Замечание - ФИО лица, оставившего замечание',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_REMARKS_SIGNER_POSITION]: {
      title: 'Акт - Замечание - Должность лица, оставившего замечание',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_REMARKS_DATE]: {
      title: 'Акт - Замечание - Дата',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_REMARKS_SIGNER_POSITION]: {
      title: 'Акт - Замечание - Дата',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTORS]: {
      title:
        'Акт - Должностные лица контрольного (надзорного) органа, участвовавшие в контрольных (надзорных) мероприятиях',
      getScrollElementId: (actId: string) => `${getActBlockId(actId)}.knoInspectors`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTOR]: {
      title:
        'Акт - Должностное лицо контрольного (надзорного) органа, участвовавшие в контрольных (надзорных) мероприятиях',
      getScrollElementId: (actId: string) => `${getActBlockId(actId)}.knoInspectors`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTOR_KNO_INSPECTOR]: {
      title:
        'Акт - ФИО должностного лица контрольного (надзорного) органа, участвовавшего в контрольных (надзорных) мероприятиях',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTOR_FULL_NAME]: {
      title:
        'Акт - ФИО должностного лица контрольного (надзорного) органа, участвовавшего в контрольных (надзорных) мероприятиях',
      getScrollElementId: (actId: string) => getActBlockId(actId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTOR_POSITION]: {
      title:
        'Акт - Должность должностного лица контрольного (надзорного) органа, участвовавшего в контрольных (надзорных) мероприятиях',
      getScrollElementId: (actId: string) => getActBlockId(actId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ACQUAINTANCE_TYPE]: {
      title: 'Акт - Сведения об ознакомлении контролируемых лиц с результатами контрольного (надзорного) мероприятия',
      getScrollElementId: (actId: string) => `${getActBlockId(actId)}.acquaintanceType`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_ACQUAINTANCE_LACK_TYPE]: {
      title:
        'Акт - Сведения об ознакомлении контролируемых лиц с результатами контрольного (надзорного) мероприятия - Причина неознакомления',
      getScrollElementId: (actId: string) => `${getActBlockId(actId)}.acquaintanceLackType`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_FIO_READER]: {
      title:
        'Акт - Сведения об ознакомлении контролируемых лиц с результатами контрольного (надзорного) мероприятия - Кто ознакомлен',
      getScrollElementId: (actId: string) => `${getActBlockId(actId)}.fioReader`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_TITLE_READER]: {
      title:
        'Акт - Сведения об ознакомлении контролируемых лиц с результатами контрольного (надзорного) мероприятия - Должность',
      getScrollElementId: (actId: string) => `${getActBlockId(actId)}.titleReader`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_REFUSER_FIO]: {
      title:
        'Акт - Сведения об ознакомлении контролируемых лиц с результатами контрольного (надзорного) мероприятия - Кто отказал',
      getScrollElementId: (actId: string) => `${getActBlockId(actId)}.refuserFio`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_REFUSER_TITLE]: {
      title:
        'Акт - Сведения об ознакомлении контролируемых лиц с результатами контрольного (надзорного) мероприятия - Должность отказавшего',
      getScrollElementId: (actId: string) => `${getActBlockId(actId)}.refuserTitle`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_DURATION_DAYS]: {
      title: 'Акт - Срок проведения (в днях)',
      getScrollElementId: (actId: string) => getActDurationDays(actId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_DURATION_HOURS]: {
      title: 'Акт - Срок проведения (в часах)',
      getScrollElementId: (actId: string) => getActDurationHours(actId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_TYPE_ACT]: {
      title: 'Акт - Вид акта',
      getScrollElementId: (actId: string) => `${getActBlockId(actId)}.typeAct`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_CANCELED_REASON]: {
      title: 'Акт - Причина невозможности проведения КНМ',
      getScrollElementId: (actId: string) => `${getActBlockId(actId)}.canceledReason`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_CANCELED_REASON_DESCRIPTION]: {
      title: 'Акт - Описание причины невозможности проведения',
      getScrollElementId: (actId: string) => `${getActBlockId(actId)}.canceledReasonDescription`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_CANCELED_REASON_DESCRIPTION_REACT_QUILL_EDITOR]: {
      title: 'Акт - Описание причины невозможности проведения',
      getScrollElementId: (actId: string) => `${getActBlockId(actId)}.canceledReasonDescription`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_DOCUMENTS_ATTACHMENTS]: {
      title: 'Акт - Файл акта',
      getScrollElementId: (actId: string) => `${getActBlockId(actId)}.document.attachments`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_FIO_AND_POSITION_SIGNER]: {
      title: 'ФИО и должность лица, подписавшего акт',
      getScrollElementId: (actId: string) => `${getActBlockId(actId)}.fioAndPositionSinger`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_FIO_SIGNER]: {
      title: 'Акт - ФИО подписавшего акт',
      getScrollElementId: (actId: string) => `${getActBlockId(actId)}.fioSigner`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_TITLE_SIGNER]: {
      title: 'Акт - Должность лица, подписавшего акт',
      getScrollElementId: (actId: string) => `${getActBlockId(actId)}.titleSigner`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_IS_VIOLATED_REQUIREMENTS_MANDATORY]: {
      title: 'Акт - Наличие обязательных требований',
      getScrollElementId: (actId: string) => `${getActBlockId(actId)}.isViolatedMandatoryRequirements`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS]: {
      title: 'Акт - Нарушенные обязательные требования',
      getScrollElementId: (actId: string) => `${getActBlockId(actId)}.isViolatedMandatoryRequirements`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_TITLE]: {
      title: 'Акт - Описание нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_TITLE_REACT_QUILL_EDITOR]: {
      title: 'Акт - Описание нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_FIXED_ON_PLACE]: {
      title: 'Акт - Нарушение устранено в ходе мероприятия',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATIONS]: {
      title: 'Акт - Нарушения обязательных требований',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_FIXED]: {
      title: 'Акт - Нарушение устранено',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_VIOLATION_REPEAT_CORRECTED]: {
      title: 'Акт - Нарушение устранено',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_FILES_VIDEO_LINK]: {
      title: 'Акт - Ссылка на файл устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_FILES]: {
      title: 'Акт - Файлы устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION]: {
      title: 'Акт - Сведения о факте устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_TYPES]: {
      title: 'Акт - Тип материала',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_TYPE]: {
      title: 'Акт - Тип материала',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_METHOD]: {
      title: 'Акт - Фактический способ устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY]: {
      title: 'Акт - Нарушенные обязательные требования',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM]: {
      title: 'Акт - Содержание требования',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_CATEGORY]: {
      title: 'Акт - Значимость последствий нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_INVOLVED_EXPERTS]: {
      title: 'Акт - Привлеченные эксперты',
      getScrollElementId: (actId: string) => getComplexDataBlockId(actId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_INVOLVED_WITNESSES_VALUE]: {
      title: 'Акт - Привлеченные к проверке свидетели',
      getScrollElementId: (actId: string) => getComplexDataBlockId(actId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENTS]: {
      title: 'Акт - Перечень осуществленных действий',
      getScrollElementId: (actId: string) => getActEventsBlockId(actId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT]: {
      title: 'Акт - Перечень осуществленных действий',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_TYPE]: {
      title: 'Акт - Тип действия, осуществляемого в рамках КНМ',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_PROTOCOL_ATTACHMENTS]: {
      title: 'Акт - Перечень осуществленных действий - Файл протокола',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_INSPECTORS]: {
      title: 'Акт - Должностное лицо, осуществившее действие',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_INSPECTOR_FULL_NAME]: {
      title: 'Акт - Должностное лицо, осуществившее действие',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_START_DATE]: {
      title: 'Акт - Дата начала действия, осуществляемого в рамках КНМ',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_STOP_DATE]: {
      title: 'Акт - Дата окончания действия, осуществляемого в рамках КНМ',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_PROTOCOL_FILE_ATTACHMENTS]: {
      title: 'Акт - Протокол проведенного действия',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_LINK_VKS]: {
      title: 'Акт - Ссылка на ВКС',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_LINK_VIDEO]: {
      title: 'Акт - Ссылка на видеозапись',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_UAV_TECHNOLOGIES]: {
      title: 'Акт - Сведения об использовании беспилотных технологий',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_UAV_TECHNOLOGIES_TYPE]: {
      title: 'Акт - Вид беспилотника',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_UAV_TECHNOLOGIES_NAME]: {
      title: 'Акт - Название беспилотника',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_NUMBER_ACT]: {
      title: 'Акт - Номер акта КНМ',
      getScrollElementId: (id: string) => getActNumberBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ACT_HOLDING_DATE_TIME]: {
      title: 'Акт - Дата и время начала проведения КНМ',
      getScrollElementId: (id: string) => getActHoldingDateTimeBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISIONS]: {
      title: 'Сведения о решениях',
      getScrollElementId: () => RESULT_DECISIONS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION]: {
      title: 'Сведения о решении',
      getScrollElementId: (id: string) => getResultDecisionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_KIND_DECISION]: {
      title: 'Вид решения',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionKindDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_NUMBER_DECISION]: {
      title: 'Номер решения',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionNumberDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_DATE_DECISION]: {
      title: 'Дата решения',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionDateDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_IS_PROSECUTION]: {
      title: 'Сведения о привлечении к ответственности по результатам контрольных (надзорных) мероприятий',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionIsProsecutionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_ACT]: {
      title: 'Сведения о решении - Акт',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_NOTE_LAWSUITS]: {
      title: 'Список описания решения',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_NOTE_LAWSUIT]: {
      title: 'Описание решения',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_NOTE_LAWSUIT_VALUE]: {
      title: 'Значение описания решения',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_NOTE_LAWSUIT_VALUE_REACT_QUILL_EDITOR]: {
      title: 'Значение описания решения',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_FIO_SIGNER]: {
      title: 'ФИО подписавшего решение',
      getScrollElementId: (resultDecisionId: string) => `${getResultDecisionBlockId(resultDecisionId)}.fioSigner`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_POSITION_SIGNER]: {
      title: 'Должность лица, подписавшего решение',
      getScrollElementId: (resultDecisionId: string) => `${getResultDecisionBlockId(resultDecisionId)}.titleSigner`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_INSPECTORS]: {
      title:
        'Сведения о решении - Должностные лица контрольного (надзорного) органа, участвовавшие в контрольных (надзорных) мероприятиях',
      getScrollElementId: (actId: string) => getResultDecisionBlockId(actId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_INSPECTOR]: {
      title:
        'Сведения о решении - Должностное лицо контрольного (надзорного) органа, участвовавшие в контрольных (надзорных) мероприятиях',
      getScrollElementId: (actId: string) => getResultDecisionBlockId(actId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_INSPECTOR_FULL_NAME]: {
      title:
        'Сведения о решении - ФИО должностного лица контрольного (надзорного) органа, участвовавшего в контрольных (надзорных) мероприятиях',
      getScrollElementId: (actId: string) => getResultDecisionBlockId(actId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_INSPECTOR_POSITION]: {
      title:
        'Сведения о решении - Должность должностного лица контрольного (надзорного) органа, участвовавшего в контрольных (надзорных) мероприятиях',
      getScrollElementId: (actId: string) => getResultDecisionBlockId(actId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_ORGANIZATION_TEMPLATE]: {
      title: 'Сведения о решении - Контролируемое лицо',
      getScrollElementId: (id: string) => getResultDecisionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_SUBJECT_TYPE]: {
      title: 'Сведения о решении - Тип контролируемого лица',
      getScrollElementId: (id: string) => getResultDecisionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_SUBJECT_TYPE_FOUNDER]: {
      title: 'Сведения о решении - Тип контролируемого лица',
      getScrollElementId: (id: string) => getResultDecisionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_OGRN]: {
      title: 'Сведения о решении - Основной государственный регистрационный номер (ОГРН)',
      getScrollElementId: (id: string) => getResultDecisionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_INN]: {
      title: 'Сведения о решении - Идентификационный номер налогоплательщика (ИНН)',
      getScrollElementId: (id: string) => getResultDecisionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_COUNTRY]: {
      title: 'Сведения о решении - Государство, в котором указанное юридическое лицо зарегистрировано',
      getScrollElementId: (id: string) => getResultDecisionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RAFP_NZA]: {
      title: 'Сведения о решении - Номер записи об аккредитации в РАФП',
      getScrollElementId: (id: string) => getResultDecisionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_KPP]: {
      title: 'Сведения о решении - Код причины постановки на учет (КПП)',
      getScrollElementId: (id: string) => getResultDecisionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_ORGANIZATION_NAME]: {
      title: 'Сведения о решении - Наименование проверяемого лица',
      getScrollElementId: (id: string) => getResultDecisionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_ADDRESS]: {
      title: 'Сведения о решении - Адрес места нахождения',
      getScrollElementId: (id: string) => getResultDecisionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITIES]: {
      title: 'Сведения о решении - Сведения о привлеченных к ответственности лицах',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionResponsibleEntities(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY]: {
      title: 'Сведения о решении - Сведения о привлеченном к ответственности лице',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionResponsibleEntitiesBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION]: {
      title: 'Сведения о решении - Сведения о привлеченном к ответственности лице',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionResponsibleEntitiesBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE]: {
      title: 'Сведения о решении - Сведения о привлеченном к ответственности лице',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionResponsibleEntitiesBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_SUBJECT_TYPE]: {
      title: 'Сведения о решении - Сведения о привлеченном к ответственности лице',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionResponsibleEntitiesBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_TYPE]: {
      title: 'Сведения о решении - Сведения о привлеченном к ответственности лице',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionResponsibleEntitiesBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_INN]: {
      title: 'Сведения о решении - ИНН привлеченного к ответственности лица',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionResponsibleEntitiesBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_OGRN]: {
      title: 'Сведения о решении - ОГРН привлеченного к ответственности лица',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionResponsibleEntitiesBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_ORGANIZATION_NAME]: {
      title: 'Сведения о решении - Наименование привлеченного к ответственности лица',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionResponsibleEntitiesBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_FULL_NAME]: {
      title: 'Сведения о решении - ФИО привлеченного к ответственности лица',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionResponsibleEntitiesBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_SNILS]: {
      title: 'Сведения о решении - СНИЛС привлеченного к ответственности лица',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionResponsibleEntitiesBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_POSITION]: {
      title: 'Сведения о решении - Должность привлеченного к ответственности лица',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionResponsibleEntitiesBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_COUNTRY]: {
      title: 'Сведения о решении - Государство привлеченного к ответственности лица',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionResponsibleEntitiesBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_RAFP]: {
      title: 'Сведения о решении - Номер записи об аккредитации в РАФП привлеченного к ответственности лица',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionResponsibleEntitiesBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_DOCUMENT]: {
      title: 'Сведения о решении - Сведения о документе, удостоверяющем личность привлеченного к ответственности лица',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionResponsibleEntitiesBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_KPP]: {
      title: 'Сведения о решении - КПП привлеченного к ответственности лица',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionResponsibleEntitiesBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_RESPONSIBILITY_TYPE]: {
      title: 'Сведения о решении - Вид наказания привлеченного к ответственности лица',
      getScrollElementId: (resultDecisionId: string) =>
        getResultDecisionResponsibleEntityResponsibilityTypeBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_PUNISHMENT_AMOUNT]: {
      title: 'Сведения о решении - Сумма наказания привлеченного к ответственности лица',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_PUNISHMENT_AMOUNT_MEASURE]: {
      title: 'Сведения о решении - Ед. измерения наказания привлеченного к ответственности лица',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_PUNISHMENT_TERM]: {
      title: 'Сведения о решении - Срок наказания привлеченного к ответственности лица',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_TYPE]: {
      title: 'Сведения о решении - Тип субъекта',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_INN_OLD]: {
      title: 'Сведения о решении - ИНН',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_OGRN_OLD]: {
      title: 'Сведения о решении - ОГРН',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_NAME_OLD]: {
      title: 'Сведения о решении - Наименование',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_POSITION_OLD]: {
      title: 'Сведения о решении - Должность',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_TYPE]: {
      title: 'Решение - Способ уведомления',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_NOTICE_DATE]: {
      title: 'Решение - Дата уведомления',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_NOTE]: {
      title: 'Решение - Примечание',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_FULL_NAME]: {
      title: 'Сведения о решении - ФИО',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_SNILS]: {
      title: 'Сведения о решении - СНИЛС',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_STRUCTURES_NPA]: {
      title:
        'Сведения о решении - Структурные единицы нормативных правовых актов, содержащих информацию о мерах ответственности контролируемых лиц',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ERVK_CONTROL_KIND_NPA_UNIT]: {
      title:
        'Сведения о решении - Структурные единицы нормативных правовых актов, содержащих информацию о мерах ответственности контролируемых лиц',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_STRUCTURES_NPA_ITEM]: {
      title:
        'Сведения о решении - Структурная единица нормативных правовых актов, содержащих информацию о мерах ответственности контролируемых лиц',
      getScrollElementId: (resultDecisionId: string) => getResultDecisionBlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_STRUCTURES_NPA]: {
      title:
        'Сведения о решении - Структурная единица нормативных правовых актов, содержащих информацию о мерах ответственности контролируемых лиц',
      getScrollElementId: (resultDecisionId: string) =>
        getResultDecisionResponsibleEntityStructuresNPABlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_STRUCTURES_NPA_ITEM]: {
      title:
        'Сведения о решении - Структурная единица нормативных правовых актов, содержащих информацию о мерах ответственности контролируемых лиц',
      getScrollElementId: (resultDecisionId: string) =>
        getResultDecisionResponsibleEntityStructuresNPABlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_STRUCTURES_NPA_ITEM_VALUE]: {
      title:
        'Сведения о решении - Структурная единица нормативных правовых актов, содержащих информацию о мерах ответственности контролируемых лиц',
      getScrollElementId: (resultDecisionId: string) =>
        getResultDecisionResponsibleEntityStructuresNPABlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_STRUCTURES_NPA_ITEM_VALUE]: {
      title:
        'Сведения о решении - Значение структурной единицы нормативных правовых актов, содержащих информацию о мерах ответственности контролируемых лиц',
      getScrollElementId: (resultDecisionId: string) =>
        getResultDecisionResponsibleEntityStructuresNPABlockId(resultDecisionId),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY]: {
      title: 'Сведения о решении - Выявленные нарушения обязательных требований',
      getScrollElementId: (resultDecisionId: string) =>
        `${getResultDecisionBlockId(resultDecisionId)}.violatedMandatoryRequirements`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_SUBJECT_TYPE_KNM]: {
      title: 'Сведения о решении - Тип учередителя',
      getScrollElementId: (id: string) => `${getResultDecisionBlockId(id)}`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_INN]: {
      title: 'Сведения о решении - Идентификационный номер налогоплательщика (ИНН)',
      getScrollElementId: (id: string) => `${getResultDecisionBlockId(id)}.${INN_LABEL_BLOCK_ID}`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_OGRN]: {
      title: 'Сведения о решении - Основной государственный регистрационный номер (ОГРН)',
      getScrollElementId: (id: string) => `${getResultDecisionBlockId(id)}.${OGRN_LABEL_BLOCK_ID}`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_ORGANIZATION_NAME]: {
      title: 'Сведения о решении - Наименование учредителя',
      getScrollElementId: (id: string) => `${getResultDecisionBlockId(id)}.${ORGANIZATION_NAME_BLOCK_ID}`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_OKVEDS]: {
      title: 'Сведения о решении - Список ОКВЭД',
      getScrollElementId: (id: string) => `${getResultDecisionBlockId(id)}.${OKVEDS_BLOCK_ID}`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_OKVED]: {
      title: 'Сведения о решении - ОКВЭД',
      getScrollElementId: (id: string) => getResultDecisionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_OKVED_OKVED]: {
      title: 'Сведения о решении - ОКВЭД',
      getScrollElementId: (id: string) => getResultDecisionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_SNILS]: {
      title: 'Сведения о решении - Страховой номер индивидуального лицевого счета (СНИЛС)',
      getScrollElementId: (id: string) => `${getResultDecisionBlockId(id)}.${SNILS_BLOCK_ID}`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_DOCUMENT]: {
      title: 'Сведения о решении - Сведения о документе, удостоверяющем личность',
      getScrollElementId: (id: string) => `${getResultDecisionBlockId(id)}.${DOCUMENT_BLOCK_ID}`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_COUNTRY]: {
      title: 'Сведения о решении - Государство, в котором указанное лицо зарегистрировано',
      getScrollElementId: (id: string) => `${getResultDecisionBlockId(id)}.${COUNTRY_BLOCK_ID}`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_RAFP_NZA]: {
      title: 'Сведения о решении - Номер записи об аккредитации в РАФП',
      getScrollElementId: (id: string) => `${getResultDecisionBlockId(id)}.${RAFP_NZA_BLOCK_ID}`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_KPP]: {
      title: 'Сведения о решении - Код причины постановки на учет (КПП)',
      getScrollElementId: (id: string) => `${getResultDecisionBlockId(id)}.${KPP_BLOCK_ID}`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_INJUNCTION_NOTE]: {
      title:
        'Информация о проведении мероприятий по предотвращению причинения вреда (ущерба) охраняемым законом ценностям',
      getScrollElementId: (resultDecisionId: string) => `${getResultDecisionBlockId(resultDecisionId)}.injunction.note`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_INJUNCTION_NOTE_REACT_QUILL_EDITOR]: {
      title:
        'Информация о проведении мероприятий по предотвращению причинения вреда (ущерба) охраняемым законом ценностям',
      getScrollElementId: (resultDecisionId: string) =>
        `${getResultDecisionBlockId(resultDecisionId)}.injunction.noteReactQuillEditor`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATIONS]: {
      title: 'Сведения о решении - Нарушения обязательных требований',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_UNIQUE]: {
      title: 'Сведения о решении - Нарушения обязательных требований',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIXED_ON_PLACE]: {
      title: 'Сведения о решении - Нарушение устранено в ходе мероприятия',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIXED]: {
      title: 'Сведения о решении - Нарушение устранено',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_PLAN_EXPLANATIONS]: {
      title: 'Сведения о решении - Пояснение инспектора к устранению',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_PLAN_EXPLANATIONS_REQUIRED]: {
      title: 'Сведения о решении - Пояснение инспектора к устранению',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_DATES]: {
      title: 'Сведения о решении - Плановая дата устранения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_DATES_REQUIRED]: {
      title: 'Сведения о решении - Плановая дата устранения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_DATE]: {
      title: 'Сведения о решении - Плановая дата устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_METHODS]: {
      title: 'Сведения о решении - Планируемый способ устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_METHODS_REQUIRED]: {
      title: 'Сведения о решении - Планируемый способ устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_FACT_METHOD]: {
      title: 'Сведения о решении -  Фактический способ устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_METHOD]: {
      title: 'Сведения о решении - Планируемый способ устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    // [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_EXPLANATION]: {
    //   title: 'Сведения о решении - Пояснение инспектора к устранению',
    //   getScrollElementId: (id: string) => getComplexDataBlockId(id),
    // },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_EXPLANATION_REACT_QUILL_EDITOR]: {
      title: 'Сведения о решении - Пояснение инспектора к устранению',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },

    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION]: {
      title: 'Сведения о решении - Фактический способ устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_TYPES]: {
      title: 'Сведения о решении - Тип материала',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_TYPE]: {
      title: 'Сведения о решении - Тип материала',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    // [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_TYPE_EXPLANATION]: {
    //   title: 'Сведения о решении - Пояснение к материалу',
    //   getScrollElementId: (id: string) => getComplexDataBlockId(id),
    // },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_TYPE_EXPLANATION_REACT_QUILL_EDITOR]: {
      title: 'Сведения о решении - Пояснение к материалу',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },

    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_METHOD]: {
      title: 'Сведения о решении - Фактический способ устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_FILES]: {
      title: 'Сведения о решении - Файлы устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_FILES_VIDEO_LINK]: {
      title: 'Сведения о решении - Ссылка на файл устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_GRADE]: {
      title: 'Сведения о решении - Оценка исправления нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENTS]: {
      title: 'Сведения о судебных решениях',
      getScrollElementId: () => JUDGMENTS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT]: {
      title: 'Сведения о судебном решении',
      getScrollElementId: (id: string) => getJudgmentBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_DATE]: {
      title: 'Сведения о судебном решении - Дата судебного решения',
      getScrollElementId: (id: string) => getJudgmentDateBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_NUMBER]: {
      title: 'Сведения о судебном решении - Номер судебного решения',
      getScrollElementId: (id: string) => getJudgmentNumberBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_ATTACHMENT]: {
      title: 'Сведения о судебном решении - Файл решения',
      getScrollElementId: (id: string) => getJudgmentAttachmentBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_KIND]: {
      title: 'Сведения о судебном решении - Вид судебного решения',
      getScrollElementId: (id: string) => getJudgmentKindBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_REGION]: {
      title: 'Сведения о судебном решении - Субъект Российской Федерации',
      getScrollElementId: (id: string) => getJudgmentRfRegionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_COURT]: {
      title: 'Сведения о судебном решении - Наименование суда',
      getScrollElementId: (id: string) => getJudgmentCourtBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_COURT_LEVEL]: {
      title: 'Сведения о судебном решении - Уровень суда',
      getScrollElementId: (id: string) => getJudgmentCourtLevelBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_ACTION]: {
      title: 'Сведения о судебном решении - Действие судебного решения',
      getScrollElementId: (id: string) => getJudgmentActionBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECTS_DATA]: {
      title: 'Сведения о судебном решении - Сведения о контролируемом лице',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA]: {
      title: 'Сведения о судебном решении - Сведения о контролируемом лице',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_GUID]: {
      title: 'Сведения о судебном решении - Сведения о контролируемом лице',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_ORG]: {
      title: 'Сведения о судебном решении - Судебный акт принят в отношении контролируемого лица',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_ORG_INFO]: {
      title: 'Сведения о судебном решении - Сведения о наказании контролируемого лица',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_ORG_INFO_PROSECUTION_TYPE]: {
      title: 'Сведения о судебном решении - Вид ответственности контролируемого лица',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_ORG_INFO_PUNISHMENT_TYPE]: {
      title: 'Сведения о судебном решении - Вид наказания контролируемого лица',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_ORG_INFO_AMOUNT_OF_PUNISHMENT]: {
      title: 'Сведения о судебном решении - Размер наказания контролируемого лица',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_ORG_INFO_PUNISHMENT_INDEX]: {
      title: 'Сведения о судебном решении - Показатель наказания контролируемого лица',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_ORG_INFO_NOTE_LAWSUITS]: {
      title: 'Сведения о судебном решении - Дополнительная информация о наказании контролируемого лица',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSON]: {
      title: 'Сведения о судебном решении - Судебный акт принят в отношении должностного лица',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSONS]: {
      title: 'Сведения о судебном решении - Сведения о наказании должностного лица',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO]: {
      title: 'Сведения о судебном решении - Сведения о наказании должностного лица',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_FIO]: {
      title: 'Сведения о судебном решении - Сведения о наказании должностного лица - ФИО',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_JOB]: {
      title: 'Сведения о судебном решении - Сведения о наказании должностного лица - Должность',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_PROSECUTION_TYPE]: {
      title: 'Сведения о судебном решении - Сведения о наказании должностного лица - Вид ответственности',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_PUNISHMENT_TYPE]: {
      title: 'Сведения о судебном решении - Сведения о наказании должностного лица - Вид наказания',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_AMOUNT_OF_PUNISHMENT]: {
      title: 'Сведения о судебном решении - Сведения о наказании должностного лица - Размер наказания',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_PUNISHMENT_INDEX]: {
      title: 'Сведения о судебном решении - Сведения о наказании должностного лица - Показатель наказания',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_NOTE_LAWSUITS]: {
      title: 'Сведения о судебном решении - Сведения о наказании должностного лица - Дополнительная информация',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_CANCELLATION_ACTS_AND_DECISIONS]: {
      title: 'Сведения о судебном решении - Сведения об актах (решениях) в рамках КНМ, которые отменены или изменены',
      getScrollElementId: (id: string) => getJudgmentBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_CANCELLATION_ACT_OR_DECISION]: {
      title: 'Сведения о судебном решении - Сведения об актах (решениях) в рамках КНМ, которые отменены или изменены',
      getScrollElementId: (id: string) => getJudgmentBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_CANCELLATION_ACT_OR_DECISION_CANCELLATION_INFO]: {
      title:
        'Сведения о судебном решении - Сведения об актах (решениях) в рамках КНМ, которые отменены или изменены - Отменено частично',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_CANCELLATION_ACT_OR_DECISION_EXPLANATION]: {
      title:
        'Сведения о судебном решении - Сведения об актах (решениях) в рамках КНМ, которые отменены или изменены - Пояснение',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_CANCELED_JUDGMENTS]: {
      title: 'Сведения о судебном решении - Сведения о судебных решениях в рамках КНМ, которые отменены',
      getScrollElementId: (id: string) => getJudgmentCanceledJudgmentsBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_CANCELED_JUDGMENT]: {
      title: 'Сведения о судебном решении - Сведения о судебном решени в рамках КНМ, которое отменено',
      getScrollElementId: (id: string) => getJudgmentCanceledJudgmentsBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_CANCELED_JUDGMENT_GUID]: {
      title: 'Сведения о судебном решении - Сведения о судебном решени в рамках КНМ, которое отменено',
      getScrollElementId: (id: string) => getJudgmentCanceledJudgmentsBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_CANCELED_JUDGMENT_SUBJECT_DATA_ORG_CANCELLATION_INFO]: {
      title:
        'Сведения о судебном решении - Сведения о судебном решени в рамках КНМ, которое отменено - Отмена принятого решения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_CANCELED_JUDGMENT_SUBJECT_DATA_ORG_EXPLANATION]: {
      title: 'Сведения о судебном решении - Сведения о судебном решени в рамках КНМ, которое отменено - Пояснение',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_CANCELED_JUDGMENT_SUBJECT_DATA_PERSON_INFO_CANCELLATION_INFO]: {
      title:
        'Сведения о судебном решении - Сведения о судебном решени в рамках КНМ, которое отменено - Отмена принятого решения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_CANCELED_JUDGMENT_SUBJECT_DATA_PERSON_INFO_EXPLANATION]: {
      title: 'Сведения о судебном решении - Сведения о судебном решени в рамках КНМ, которое отменено - Пояснение',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_CANCELED_JUDGMENT_SUBJECT_DATA_ACT_OR_DECISION_CANCELLATION_INFO]: {
      title:
        'Сведения о судебном решении - Сведения о судебном решени в рамках КНМ, которое отменено - Отмена принятого решения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.JUDGMENT_CANCELED_JUDGMENT_SUBJECT_DATA_ACT_OR_DECISION_EXPLANATION]: {
      title: 'Сведения о судебном решении - Сведения о судебном решени в рамках КНМ, которое отменено - Пояснение',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REQUIREMENTS_NPA_ERKNM_ARRAY]: {
      title: 'Обязательные требования, подлежащие проверке',
      getScrollElementId: () => REQUIREMENTS_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REQUIREMENTS_NPA_ERKNM]: {
      title: 'Обязательные требования, подлежащие проверке',
      getScrollElementId: (id: string) => getRequirementBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.REQUIREMENTS_NPA_ERKNM_MANDATORY]: {
      title: 'Обязательные требования, подлежащие проверке',
      getScrollElementId: (id: string) => getRequirementBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.SUSPENSION_EVENT_ATTACHMENTS]: {
      title: 'Сведения о приостановлении срока проведения КНМ - Файл решения',
      getScrollElementId: (id: string) => getSuspensionEventBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.SUSPENSION_EVENT_EVENT]: {
      title: 'Сведения о приостановлении срока проведения КНМ - Действие',
      getScrollElementId: (id: string) => getSuspensionEventBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.SUSPENSION_EVENT_DECISION_DATE_TIME]: {
      title: 'Сведения о приостановлении срока проведения КНМ - Дата и время издания решения',
      getScrollElementId: (id: string) => getSuspensionEventBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.SUSPENSION_EVENT_DECISION_NUMBER]: {
      title: 'Сведения о приостановлении срока проведения КНМ - Номер решения',
      getScrollElementId: (id: string) => getSuspensionEventBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.SUSPENSION_EVENT_DECISION_PLACE]: {
      title: 'Сведения о приостановлении срока проведения КНМ - Место вынесения решения',
      getScrollElementId: (id: string) => getSuspensionEventBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.SUSPENSION_EVENT_REGION]: {
      title: 'Сведения о приостановлении срока проведения КНМ - Место вынесения решения',
      getScrollElementId: (id: string) => getSuspensionEventBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.SUSPENSION_EVENT_MANUAL_ADDRESS]: {
      title: 'Сведения о приостановлении срока проведения КНМ - Место вынесения решения',
      getScrollElementId: (id: string) => getSuspensionEventBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.SUSPENSION_EVENT_START_DATE]: {
      title: 'Сведения о приостановлении срока проведения КНМ - Дата начала приостановления',
      getScrollElementId: (id: string) => getSuspensionEventBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.SUSPENSION_EVENT_STOP_DATE]: {
      title: 'Сведения о приостановлении срока проведения КНМ - Дата окончания приостановления',
      getScrollElementId: (id: string) => getSuspensionEventBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.NOTIFICATIONS]: {
      title: 'Информация об уведомлениях',
      getScrollElementId: () => KNM_NOTIFICATION_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.NOTIFICATION]: {
      title: isEnablePaperlessPassportDocument ? 'Уведомление о решении' : 'Информация об уведомлении',
      getScrollElementId: (id: string) => getNotificationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.NOTIFICATION_DATE]: {
      title: `${isEnablePaperlessPassportDocument ? 'Уведомление о решении' : 'Информация об уведомлении'} - Дата`,
      getScrollElementId: (id: string) => getNotificationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.NOTIFICATION_TYPE]: {
      title: `${
        isEnablePaperlessPassportDocument ? 'Уведомление о решении' : 'Информация об уведомлении'
      } - Способ уведомления`,
      getScrollElementId: (id: string) => getNotificationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.NOTIFICATION_COMMENT]: {
      title: `${
        isEnablePaperlessPassportDocument ? 'Уведомление о решении' : 'Информация об уведомлении'
      } - Примечание`,
      getScrollElementId: (id: string) => getNotificationBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_RESULT_PRESCRIPTION]: {
      title: 'Соглашение - Предписание',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.prescription`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS]: {
      title: 'Соглашение - Нарушения, включенные в соглашение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.violations`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATIONS]: {
      title: 'Соглашение - Нарушения, включенные в соглашение - Нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIX_FACT_METHOD]: {
      title: 'Соглашение - Фактический способ устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES]: {
      title: 'Соглашение - Сведения о факте устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPES]: {
      title: 'Соглашение - Тип материала',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPE]: {
      title: 'Соглашение - Тип материала',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    // [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPE_EXPLANATION]: {
    //   title: 'Соглашение - Пояснение к материалу',
    //   getScrollElementId: (id: string) => getComplexDataBlockId(id),
    // },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPE_EXPLANATION_REACT_QUILL_EDITOR]: {
      title: 'Соглашение - Пояснение к материалу',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },

    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_METHOD]: {
      title: 'Соглашение - Фактический способ устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_FILES]: {
      title: 'Соглашение - Файлы устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_FILES_VIDEO_LINK]: {
      title: 'Соглашение - Ссылка на файл устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_GRADE]: {
      title: 'Соглашение - Оценка исправления нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_TYPE]: {
      title: 'Соглашение - Ходатайство контролируемого лица - Лицо, с которым заключается соглашение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganizationType`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ATTACHMENT]: {
      title: 'Соглашение - Файл ходатайства',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionAttachment`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_INN]: {
      title: 'Соглашение - Ходатайство контролируемого лица - ИНН',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganization.inn`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_OGRN]: {
      title: 'Соглашение - Ходатайство контролируемого лица - ОГРН',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganization.ogrn`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_SNILS]: {
      title: 'Соглашение - Ходатайство контролируемого лица - СНИЛС',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganization.snils`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_SUBJECT_TYPE]: {
      title: 'Соглашение - Ходатайство контролируемого лица - Тип контролируемого лица',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganization.subjectType`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_ORGANIZATION_NAME]: {
      title: 'Соглашение - Ходатайство контролируемого лица - Наименование проверяемого лица',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganization.organizationName`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_ORGANIZATION_LOCATION_ADDRESS]: {
      title: 'Соглашение - Ходатайство контролируемого лица - Адрес места нахождения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganization.locationAddress`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVAL_OF_AGREEMENT]: {
      title: 'Соглашение - Решение об утверждении ходатайства',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approvalOfAgreement`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVAL_OF_AGREEMENT_ATTACHMENT]: {
      title: 'Соглашение - Файл решения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approvalOfAgreementAttachment`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_ELIMINATE_VIOLATIONS_NUMBER]: {
      title: 'Соглашение - Соглашение об устранении нарушений',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.eliminateViolationsNumber`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_CONCLUSION_DATE]: {
      title: 'Соглашение - Дата заключения соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.conclusionDate`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_COMPLETION_DATE]: {
      title: 'Соглашение - Срок исполнения соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.termOfExecutionAgreement`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_ELIMINATE_VIOLATIONS_ATTACHMENT]: {
      title: 'Соглашение - Файл соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.eliminateViolationsAttachment`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_APPLICATION_FOR_CONSIDERATION_ATTACHMENT]: {
      title: 'Соглашение - Заявление в органы прокуратуры о рассмотрении соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.applicationForConsiderationAttachment`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATION_CORRECTION_PROGRAM_ATTACHMENTS]: {
      title: 'Соглашение - Программа устранения нарушений',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.violationCorrectionProgramAttachments`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_PROSECUTOR_ORGANIZATION]: {
      title: 'Соглашение - Наименование прокуратуры',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.prosecutorOrganization`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_NOTE]: {
      title: 'Соглашение - Комментарий',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.note`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_APPROVED]: {
      title: 'Соглашение - Решение по заявлению',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.approved`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_NUMBER_DECISION]: {
      title: 'Соглашение - Номер решения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.numberDecision`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_DATE_DECISION]: {
      title: 'Соглашение - Дата решения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.dateDecision`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_WHO_MADE_DECISION]: {
      title: 'Соглашение - Кем принято решение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.whoMadeDecision`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_TITLE_SIGNER]: {
      title: 'Соглашение - Должность лица, подписавшего решение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.titleSigner`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_ATTACHMENT]: {
      title: 'Соглашение - Файл решения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.attachment`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_FIO_SIGNER]: {
      title: 'Соглашение - ФИО подписавшего соглашение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.fioSigner`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_TITLE_SIGNER]: {
      title: 'Соглашение - Должность лица, подписавшего соглашение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.titleSigner`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_TERMINATE_TERMINATION_REASONS]: {
      title: 'Соглашение - Основания для признания соглашения неисполненным и расторжения соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.terminate.terminationReasons`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_TERMINATE_TERMINATION_REASONS_ITEM]: {
      title: 'Соглашение - Основания для признания соглашения неисполненным и расторжения соглашения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_TERMINATE_DECISION_TERMINATION_ATTACHMENT]: {
      title: 'Соглашение - Решение о признании соглашения неисполненным и расторжении соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.terminate.decisionTerminationAttachment`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_TERMINATE_FIO_SIGNER]: {
      title: 'Соглашение - ФИО принявшего решение об изменении',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.terminate.fioSigner`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_TERMINATE_TITLE_SIGNER]: {
      title: 'Соглашение - Должность принявшего решение об изменении',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.terminate.titleSigner`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_TERMINATE_TITLE_SIGNER_LABEL]: {
      title: 'Соглашение - Должность принявшего решение об изменении',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.terminate.titleSigner`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_EXECUTION_DECISION]: {
      title: 'Соглашение - Решение об исполнении соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.execution.decision`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_EXECUTION_EXECUTION_DATE]: {
      title: 'Соглашение - Фактическая дата исполнения соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.execution.executionDate`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_EXECUTION_TITLE_SIGNER]: {
      title: 'Соглашение - ФИО принявшего решение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.execution.fioSigner`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_EXECUTION_FIO_SIGNER]: {
      title: 'Соглашение - Должность принявшего решение об изменении',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.execution.titleSigner`,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_TYPES]: {
      title: 'Соглашение - Вид изменения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_TYPES_ITEM]: {
      title: 'Соглашение - Вид изменения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_REASON]: {
      title: 'Соглашение - Основание для изменения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_REASON_ITEM]: {
      title: 'Соглашение - Основание для изменения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_ATTACHMENTS]: {
      title: 'Соглашение - Решение об изменении',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_TERM_OF_EXECUTION_AGREEMENT]: {
      title: 'Соглашение - Новый срок исполнения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_UPDATED_AGREEMENT_ATTACHMENTS]: {
      title: 'Соглашение - Обновленная версия соглашения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_PETITION_ATTACHMENTS]: {
      title: 'Соглашение - Ходатайство об изменении соглашения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_FIO_SIGNER]: {
      title: 'Соглашение - ФИО принявшего решение об изменении',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_TITLE_SIGNER]: {
      title: 'Соглашение - Должность принявшего решение об изменении',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.CHANGE_PLAN_REASON_APPROVE_ERKNM]: {
      title: 'Принять изменения в КНМ',
      getScrollElementId: () => KNM_APPROVE_CHANGE_KNM,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.CHANGE_PLAN_REASON_APPROVE_FIO_SIGNER]: {
      title: 'Кем принято решение',
      getScrollElementId: () => KNM_APPROVE_CHANGE_KNM,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.CHANGE_PLAN_REASON_APPROVE_DATE_DECISION]: {
      title: 'Дата решения',
      getScrollElementId: () => KNM_APPROVE_CHANGE_KNM,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.CHANGE_PLAN_REASON_APPROVE_TITLE_SIGNER]: {
      title: 'Должность лица, подписавшего решение',
      getScrollElementId: () => KNM_APPROVE_CHANGE_KNM,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.CHANGE_PLAN_REASON_APPROVE_FILE]: {
      title: 'Файл решения',
      getScrollElementId: () => KNM_APPROVE_CHANGE_KNM,
    },
  };
};
